import { sendToken } from '../../CertificationWabaByPoli/MetaSDK/service';
import { toast } from 'react-toastify';

// Note: Este arquivo é um serviço puro, não pode usar hooks diretamente
// As traduções precisam ser passadas como parâmetro ou as mensagens devem ser traduzidas no componente que chama esta função
// Por enquanto, vamos manter as mensagens hardcoded aqui e traduzir nos componentes que usam este serviço

export async function sendCoexistenceToken(debugToken, customer) {
  // Use the existing sendToken function but with coexistence-specific parameters
  // For coexistence flow, we use the user's token directly (requestFromWabaService = false)
  // This is necessary because the backend's SYSTEM_USER_ACCESS_TOKEN doesn't have access
  // to the user's WABAs from a different App ID (coexistence uses a different Meta App)
  const requestFromWabaService = false;
  
  try {
    const data = await sendToken(debugToken, requestFromWabaService);
    
    if (!data) {
      toast.error('Não foi possível obter informações da conta WhatsApp Business. Verifique suas permissões.');
      return null;
    }

    // NOTE: This function is now only used as a fallback for WABA flow
    // For coexistence flow, data comes directly from the Facebook event callback
    // The data structure from sendToken is: [{ id, name, status, waba_accounts: [{ id, name, phone_numbers: [] }] }]
    // We need to flatten this to match the expected format in FacebookConnection
    
    if (Array.isArray(data) && data.length > 0) {
      const business = data[0];
      
      if (business.waba_accounts && business.waba_accounts.length > 0) {
        const waba = business.waba_accounts[0];
        const phone = waba.phone_numbers && waba.phone_numbers.length > 0 ? waba.phone_numbers[0] : null;
        
        // Return flattened structure with coexistence-specific fields
        return [{
          waba_id: waba.id,
          business_id: business.id,
          phone_number_id: phone ? phone.id : null,
          phone_number: phone ? phone.display_phone_number : null,
          display_name: phone ? phone.verified_name : waba.name,
          access_token: debugToken, // Pass the user's token for API calls
          coexistenceEnabled: true,
          shareChats: true,
          connectionType: 'coexistence'
        }];
      }
    }

    return data;
  } catch (error) {
    console.error('Erro ao enviar token de coexistência:', error);
    
    // Handle specific error types
    if (error.response) {
      const status = error.response.status;
      const errorData = error.response.data;
      
      switch (status) {
        case 400:
          toast.error(
            errorData?.error?.message || 
            'Requisição inválida. Verifique os dados e tente novamente.'
          );
          break;
        case 401:
          toast.error('Não autorizado. Você precisa fazer login novamente.');
          break;
        case 403:
          toast.error(
            'Você não tem permissão para acessar esta conta do WhatsApp Business. '
            + 'Certifique-se de que você é administrador da conta.'
          );
          break;
        case 404:
          toast.error('Conta do WhatsApp Business não encontrada.');
          break;
        case 500:
          toast.error('Erro no servidor. Tente novamente mais tarde.');
          break;
        default:
          toast.error(
            `Erro ao conectar com o WhatsApp Business (${status}). `
            + 'Entre em contato com o suporte se o problema persistir.'
          );
      }
    } else if (error.request) {
      // Request made but no response received
      toast.error(
        'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.'
      );
    } else {
      // Something else happened
      toast.error('Erro inesperado ao processar a requisição. Tente novamente.');
    }
    
    throw error;
  }
}
